<!-- 固定资产 -->

<template>
  <div class="applyInitiation_personal applyInitiation_work">
    <div class="applyInitiation_personal_head">
      <span>固定资产</span>
      <span class="red">(选填)</span>
    </div>
    <div class="applyInitiation_personal_main">
      <ul class="applyInitiation_personal_list clearfix">
        <li class="clearfix">
          <div class="applyInitiation_personal_list_name left">住房情况</div>
          <el-select :disabled="isDisabled" v-model="propertyFormData.ass_buy_house" placeholder="请选择" @change="changeHouse">
            <el-option v-for="(item, index) in houseList" :key="index" :label="item" :value="item"> </el-option>
          </el-select>
        </li>
        <li class="clearfix">
          <div class="applyInitiation_personal_list_name left">住房是否有贷款</div>
          <el-select :disabled="isDisabled" v-model="propertyFormData.house_money" placeholder="请选择">
            <el-option v-for="(item, index) in houseMoneyList" :key="index" :label="item" :value="item"> </el-option>
          </el-select>
        </li>
        <li class="clearfix">
          <div class="applyInitiation_personal_list_name left">买车情况</div>
          <el-select :disabled="isDisabled" v-model="propertyFormData.ass_buy_car" placeholder="请选择" @change="changeCar">
            <el-option v-for="(item, index) in carList" :key="index" :label="item" :value="item"> </el-option>
          </el-select>
        </li>
        <li class="clearfix">
          <div class="applyInitiation_personal_list_name left">车子是否有贷款</div>
          <el-select :disabled="isDisabled" v-model="propertyFormData.car_money" placeholder="请选择">
            <el-option v-for="(item, index) in carMoneyList" :key="index" :label="item" :value="item"> </el-option>
          </el-select>
        </li>
        <li class="clearfix">
          <div class="applyInitiation_personal_list_name left">存款情况</div>
          <el-select :disabled="isDisabled" v-model="propertyFormData.ckqk" placeholder="请选择">
            <el-option v-for="(item, index) in depositList" :key="index" :label="item" :value="item"> </el-option>
          </el-select>
        </li>
        <li class="clearfix">
          <div class="applyInitiation_personal_list_name left">债务情况</div>
          <el-select :disabled="isDisabled" v-model="propertyFormData.zwqk" placeholder="请选择">
            <el-option v-for="(item, index) in debtList" :key="index" :label="item" :value="item"> </el-option>
          </el-select>
        </li>
      </ul>
      <div class="uploadImg_identity_ul clearfix">
        <div class="uploadImg_identity_ul_left">
          <div class="uploadImg_identity_ul_top" v-if="isHouse">
            <input :disabled="isDisabled" type="file" @input="uploadHouseImg" />
            <img :src="houseImgUrl" alt="" v-if="houseImgUrl" />
            <img src="../../../assets/image/apply/2.png" alt="" v-else />
          </div>
        </div>
        <div class="uploadImg_identity_ul_left">
          <div class="uploadImg_identity_ul_top" v-if="isCar">
            <input :disabled="isDisabled" type="file" @input="uploadCarImg" />
            <img :src="carImgUrl" alt="" v-if="carImgUrl" />
            <img src="../../../assets/image/apply/3.png" alt="" v-else />
          </div>
        </div>
      </div>
      <div class="copy" @click="handleSubmitProperty" v-if="!isDisabled">保存并继续</div>
    </div>
  </div>
</template>

<script>
import $DB from '../../../util/debounce'
import { uploadFile } from '../../../util/upload'

export default {
  name: 'Property',
  props: {
    // 用户信息
    userInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      propertyInfo: { ass_status: 0 }, // 固定资产

      houseList: [], // 住房列表
      carList: [], // 车辆列表
      houseMoneyList: [], // 房子是否有贷款列表
      carMoneyList: [], // 车子是否有贷款列表
      depositList: [], // 存款情况列表
      debtList: [], // 债务情况列表

      propertyFormData: {
        ass_buy_house: '', // 住房情况
        ass_buy_car: '', // 买车情况
        house_pic: '',
        car_pic: '',

        // 202406 新增
        house_money: '', // 房子是否有贷款
        car_money: '', // 车子是否有贷款

        // 202407 新增
        ckqk: '', // 存款情况
        zwqk: '', // 债务情况
      },
      isHouse: false,
      isCar: false,
      houseImgUrl: '',
      carImgUrl: '',
    }
  },
  computed: {
    isDisabled() {
      return this.userInfo.check_status === 2 || this.userInfo.check_status === 3
    },
  },
  created() {
    this.funLoadProperty()

    // 类型:1性别:2 民族;3身高;4体重:5属相;6星座:7血型;8信仰;9 籍贯;10长期居住地;11学历;12毕业院校【对应School表];13公司类型:14职业:15收入:16兄弟姐妹几人;17婚姻状况:18住房情况:19买车情况:20是否抽烟;21是否喝酒;22是否有孩子;23 有几个孩子:24 是否想要孩子;25 何时结婚;26年龄;27身高;28期待结婚时间;29所在地:30推荐指数;32 工作性质;33住房是否有贷款;34车辆是否有贷款;35父母亲情况;36父母亲工作情况;37父母亲是否有退休金;38是否原生家庭;39感情经历:40孩子情况:41抚养费;42 健康情况；43 存款情况；44 债务情况
    const obj = {
      18: 'houseList', // 住房列表
      19: 'carList', // 车辆列表
      33: 'houseMoneyList', // 房子是否有贷款列表
      34: 'carMoneyList', // 车子是否有贷款列表
      43: 'depositList', // 存款情况列表
      44: 'debtList', // 债务情况列表
    }
    for (const key in obj) {
      this.funLodeCateList(+key, obj[key])
    }
  },
  methods: {
    //获取固定资产
    funLoadProperty() {
      this.$axios.post('/api/member/getUserAssets').then((res) => {
        this.propertyInfo.ass_status = res.data.data.ass_status
        if (res.data.code === 0) {
          this.houseImgUrl = res.data.data.house_pic_img
          this.carImgUrl = res.data.data.car_pic_img
          this.propertyInfo = res.data.data
          res.data.data.house_pic_img ? (this.isHouse = true) : (this.isHouse = false)
          res.data.data.car_pic_img ? (this.isCar = true) : (this.isCar = false)
          for (const key in this.propertyFormData) {
            this.propertyFormData[key] = this.propertyInfo[key]
          }
          this.isHouse = true
          this.isCar = true
        }
      })
    },

    /**
     * 获取下拉选择内容
     * @param {Number} type 类型
     * @param {String} propName data 中的字段名
     */
    funLodeCateList(type, propName) {
      this.$axios.post('/api/index/cateList', { type }).then((res) => {
        if (res.data.code === 0) {
          this[propName] = res.data.data[0].cate_name
        }
      })
    },

    //判断是否自有住房
    changeHouse(e) {
      e == '暂未购房' ? (this.isHouse = false) : (this.isHouse = true)
    },
    //判断是否自有车辆
    changeCar(e) {
      e == '暂未购车' ? (this.isCar = false) : (this.isCar = true)
    },

    //上传房产证照片
    uploadHouseImg: $DB(async function (event) {
      if (!event.target.files.length) return

      const fileInfo = event.target.files[0]
      const result = await uploadFile(fileInfo, this)
      this.propertyFormData.house_pic = result.id
      this.houseImgUrl = result.url
    }),
    //上传行车证照片
    uploadCarImg: $DB(async function (event) {
      if (!event.target.files.length) return

      const fileInfo = event.target.files[0]
      const result = await uploadFile(fileInfo, this)
      this.propertyFormData.car_pic = result.id
      this.carImgUrl = result.url
    }),

    //上传固定资产
    handleSubmitProperty: $DB(function () {
      // if (!this.propertyFormData.ass_buy_house) return this.$message.error('请选择住房情况')
      // if (!this.propertyFormData.ass_buy_car) return this.$message.error('请选择买车情况')

      this.$axios.post('/api/member/userAssets', this.propertyFormData).then((res) => {
        if (res.data.code === 0) {
          this.$message.success(res.data.msg)
        } else {
          this.$message.error(res.data.msg)
        }
      })
    }),
  },
}
</script>

<style lang="scss" src="../index.scss" scoped></style>
